import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let ColumnList;

class Column_list extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: ColumnList };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(import(
      /* webpackChunkName: "components/javascript/crux-components/column-list" */
      "../../../components/javascript/crux-components/column-list"
    ).then(function(res) {
      ColumnList = res.ColumnList;
    }));

    
;
  }
}

export { Column_list };
